import React from "react";
import { Link } from "react-router-dom";
import "./CallToAction.css";

const CallToAction = ({
  title = "Contact us to learn more first-hand and let us give you a free, no-obligation quote.",
  subtitle = "We’re committed to providing the highest quality gutter installation and protection services in Central Florida.",
  primaryText = "📞 Call Now: (352) 812-0831",
  secondaryText = "Get Your Free Estimate",
}) => {
  return (
    <div className="cta-content-wrapper">
      <div className="cta-content">
        <h2 className="cta-title">{title}</h2>
        <p className="cta-subtext">{subtitle}</p>
        <div className="cta-buttons">
          <a href="tel:352-812-0831" className="cta-button primary">
            {primaryText}
          </a>
          <Link to="/free-estimate" className="cta-button secondary">
            {secondaryText} <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;